/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserInviteResponse {
    getFixupPrototypeFunction() { return UserInviteResponse.fixupPrototype; }

    static newInstance(model: Partial<UserInviteResponse>): UserInviteResponse {
        let obj = Object.assign(new UserInviteResponse(), model);
        UserInviteResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserInviteResponse>): UserInviteResponse {
        if (!model) return null;
        return UserInviteResponse.newInstance(<UserInviteResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserInviteResponse) {
        if (!obj) return;

        models.UserInviteResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserInviteResponse): boolean {
        Object.setPrototypeOf(obj, UserInviteResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the newly invited User
     */
    user_id: string;

}
